export default "__VITE_ASSET__DtfdL7n2__"